import React, { useEffect, useState } from 'react';

import { useBodyTypesFilter } from '@/hooks/filters/body-types-filter.hook';
import { useBrandsRangesFilter } from '@/hooks/filters/brands-ranges-filter.hook';
import { useColorsFilter } from '@/hooks/filters/colors-filter.hook';
import { useDoorsFilter } from '@/hooks/filters/doors-filter.hook';
import { useDrivetrainFilter } from '@/hooks/filters/drivetrain-filter.hook';
import { useFeaturesFilter } from '@/hooks/filters/features-filter.hook';
import { useFinanceFilter } from '@/hooks/filters/finance-filter.hook';
import { useFuelConsumptionFilter } from '@/hooks/filters/fuel-consumption.hook';
import { useFuelTypeFilter } from '@/hooks/filters/fuel-type-filter.hook';
import { useMileageFilter } from '@/hooks/filters/mileage-filter.hook';
import { usePriceFilter } from '@/hooks/filters/price-filter.hook';
import { useTransmissionTypeFilter } from '@/hooks/filters/transmission-type-filter.hook';
import { useYearsFilterHook } from '@/hooks/filters/years-filter.hook';

import styles from './mobile-filters-counter.module.scss';

export const FiltersCounter: React.FC<{
  noTags?: boolean;
  filtersVisible?: boolean;
  setFiltersVisible: (isVisible: boolean) => void;
}> = ({ noTags, filtersVisible, setFiltersVisible }) => {
  const [filtersNumber, setFiltersNumber] = useState(0);

  const { hasSelectedPriceFilter } = usePriceFilter();

  const { hasSelectedYearsFilter } = useYearsFilterHook();

  const { hasSelectedMileageFilter } = useMileageFilter();

  const { selectedFinanceFilter } = useFinanceFilter();

  const { brandsRangesSelectedFilters, hasSelectedBrandsRanges } =
    useBrandsRangesFilter();

  const { selectedColorFilters, hasSelectedColorFilters } = useColorsFilter();

  const { bodyTypesSelectedFilters, hasSelectedBodyTypes } =
    useBodyTypesFilter();

  const { selectedDoorsFilter, hasSelectedDoorsFilter } = useDoorsFilter();

  const { hasSelectedTransmissionFilter, selectedTransmissionTypes } =
    useTransmissionTypeFilter();

  const { selectedFuelTypes, hasSelectedFuelTypesFilter } = useFuelTypeFilter();

  const { selectedDrivetrainTypes, hasSelectedDrivetrainFilter } =
    useDrivetrainFilter();

  const { selectedFeatures, hasSelectedFeaturesFilter } = useFeaturesFilter();

  const { hasSelectedConsumptionFilter } = useFuelConsumptionFilter();

  const isFilterListVisible =
    hasSelectedBrandsRanges ||
    hasSelectedFeaturesFilter ||
    hasSelectedBodyTypes ||
    hasSelectedColorFilters ||
    hasSelectedDoorsFilter ||
    hasSelectedTransmissionFilter ||
    hasSelectedFuelTypesFilter ||
    hasSelectedDrivetrainFilter ||
    selectedFinanceFilter ||
    hasSelectedYearsFilter ||
    hasSelectedMileageFilter ||
    hasSelectedPriceFilter ||
    hasSelectedConsumptionFilter;

  useEffect(() => {
    let newFiltersNumber = 0;

    if (brandsRangesSelectedFilters && brandsRangesSelectedFilters.length > 0) {
      newFiltersNumber += brandsRangesSelectedFilters.length;
    }
    if (hasSelectedPriceFilter) {
      newFiltersNumber += 1;
    }
    if (hasSelectedYearsFilter) {
      newFiltersNumber += 1;
    }
    if (selectedFinanceFilter) {
      newFiltersNumber += 1;
    }
    if (hasSelectedMileageFilter) {
      newFiltersNumber += 1;
    }
    if (bodyTypesSelectedFilters && bodyTypesSelectedFilters.length > 0) {
      newFiltersNumber += bodyTypesSelectedFilters.length;
    }
    if (selectedColorFilters && selectedColorFilters.length > 0) {
      newFiltersNumber += selectedColorFilters.length;
    }
    if (selectedDoorsFilter && selectedDoorsFilter.length > 0) {
      newFiltersNumber += selectedDoorsFilter.length;
    }
    if (selectedTransmissionTypes && selectedTransmissionTypes.length > 0) {
      newFiltersNumber += selectedTransmissionTypes.length;
    }
    if (selectedFuelTypes && selectedFuelTypes.length > 0) {
      newFiltersNumber += selectedFuelTypes.length;
    }
    if (selectedDrivetrainTypes && selectedDrivetrainTypes.length > 0) {
      newFiltersNumber += selectedDrivetrainTypes.length;
    }
    if (selectedFeatures && selectedFeatures.length > 0) {
      newFiltersNumber += selectedFeatures.length;
    }
    if (hasSelectedConsumptionFilter) {
      newFiltersNumber += 1;
    }

    setFiltersNumber(newFiltersNumber);
  }, [
    brandsRangesSelectedFilters,
    hasSelectedPriceFilter,
    hasSelectedYearsFilter,
    selectedFinanceFilter,
    hasSelectedMileageFilter,
    bodyTypesSelectedFilters,
    selectedColorFilters,
    selectedDoorsFilter,
    selectedTransmissionTypes,
    selectedFuelTypes,
    selectedDrivetrainTypes,
    selectedFeatures,
    hasSelectedConsumptionFilter,
  ]);

  if (!isFilterListVisible) {
    return null;
  }

  return (
    <div className={styles.filtersCounterWrapper}>
      {filtersVisible ? (
        <div
          className={styles.filtersCounterHide}
          onClick={() => !noTags && setFiltersVisible(false)}
        >
          <span className={styles.filtersCounterHideLabel}>Hide</span>
        </div>
      ) : (
        <div
          className={styles.filtersCounter}
          onClick={() => !noTags && setFiltersVisible(true)}
        >
          <span className={styles.filtersCounterLabel}>
            Filters ({filtersNumber})
          </span>
        </div>
      )}
    </div>
  );
};
